define([
	"dojo/_base/declare",
	"csi/heading/PropertyName",
	"csi/locale",
	"csi/xml"
], function(declare,PropertyName,locale, xml) {

	return declare(PropertyName, {
		toValue: function(/*Context*/ctx, /*Heading*/h) {
			// summary: replace revision name with Total label
			if (ctx.getNodeURL() == ctx.view.getViewURL()) {
				return locale.resource("Total");
			}

			var node = ctx.getNode();
			var value = this.inherited(arguments);

			if (node.$Type == "SubQuestion") {
			    value = locale.resource("SubQuestionApplicableIf", [value, locale.getEnumName(node.ApplicableQuestionResponse)]);
			}

			return value;
		}
	});
});
